<template>
    <nav>
        <ul>
            <li>
                <router-link to="/">Home</router-link>
            </li>
            <li v-if="currentRouteName !=='About'">
                <router-link to="/about">About</router-link>
            </li>
            <li v-if="currentRouteName !=='Contact'">
                <router-link to="/contact">Contact</router-link>
            </li>
            <li v-if="currentRouteName !=='Credits'">
                <router-link to="/credits">Credits</router-link>
            </li>
            <li v-if="currentRouteName !=='Privacy'">
                <router-link to="/privacy">Privacy</router-link>
            </li>
        </ul>
    </nav>
</template>

<script>
    export default {
        name: "NavInfo",
        computed: {
            currentRouteName() {
                return this.$route.name;
            }
        }
    }
</script>

<style scoped>
    ul {
        padding: 0;
        margin: 32.16px 0;
        font-size: 1.5em;
    }

    li {
        list-style: none;
        padding: 0 4em 1em 0;
    }

    ul li a {
        text-decoration: none;
    }

    @media screen and (max-width: 659px) {
        nav {
            font-size: .75em;
        }

        ul {
            margin: .5em 0;
        }

        ul li {
            display: inline;
            padding: 0 1em 1em 0;
        }
    }

    @media screen and (min-width: 660px) {
        nav {
            position: fixed;
            left: 2em;
            top: 5em;
        }
    }
</style>
